<template>
  <div>
    <tarrif-was-activated
      v-if="justNowActivatedTarrif"
      :tariff="justNowActivatedTarrif"
    />
    <unsuccess-payment
      v-else-if="showUnsuccessPayment"
      :paymentIsUnsuccess="paymentIsUnsuccess"
      :chargeIsFailedFirstTime="chargeIsFailedFirstTime"
      :chargeIsFailedSecondTime="chargeIsFailedSecondTime"
      :nextPaymentDate="nextPaymentDate"
    />
    <low-balance
      v-else-if="emailLowBalanceData"
      email
      :balanceData="emailLowBalanceData"
    />
    <low-balance
      v-else-if="pushLowBalanceData"
      push
      :balanceData="pushLowBalanceData"
    />
    <low-balance
      v-else-if="webhookLowBalanceData"
      webhook
      :balanceData="webhookLowBalanceData"
    />
    <low-balance
      v-else-if="smsLowBalanceData"
      sms
      :balanceData="smsLowBalanceData"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { userNotificationsUpdateMinInterval } from 'src/utils/config';
import NotificationsKeys from 'src/models/NotificationsKeys';
import TarrifWasActivated from './TarrifWasActivated';
import UnsuccessPayment from './UnsuccessPayment';
import LowBalance from './LowBalance';

export default {
  components: {
    TarrifWasActivated,
    UnsuccessPayment,
    LowBalance,
  },
  data: () => ({
  }),
  mounted() {
    this.autoUpdateUserNotifications();
  },
  computed: {
    ...mapState('userNotifications', ['userNotifications']),
    ...mapState('userData', ['loginInfo']),
    emailLowBalanceData() {
      const foundRow = this.getUserNotificationByKey(NotificationsKeys.emailLowBalance);
      return foundRow && foundRow.data;
    },
    pushLowBalanceData() {
      const foundRow = this.getUserNotificationByKey(NotificationsKeys.pushLowBalance);
      return foundRow && foundRow.data;
    },
    webhookLowBalanceData() {
      const foundRow = this.getUserNotificationByKey(NotificationsKeys.webhookLowBalance);
      return foundRow && foundRow.data;
    },
    smsLowBalanceData() {
      const foundRow = this.getUserNotificationByKey(NotificationsKeys.smsLowBalance);
      return foundRow && foundRow.data;
    },
    paymentIsUnsuccess() {
      return !!this.getUserNotificationByKey(NotificationsKeys.paymentIsUnsuccess);
    },
    chargeIsFailedFirstTime() {
      return !!this.getUserNotificationByKey(NotificationsKeys.chargeIsFailedFirstTime);
    },
    chargeIsFailedSecondTime() {
      return !!this.getUserNotificationByKey(NotificationsKeys.chargeIsFailedSecondTime);
    },
    justNowActivatedTarrif() {
      const foundRow = this.getUserNotificationByKey(NotificationsKeys.tariffWasActivated); // eslint-disable-line max-len
      return foundRow && foundRow.data && foundRow.data.currentTariffPlan;
    },
    showUnsuccessPayment() {
      return this.paymentIsUnsuccess || this.chargeIsFailedFirstTime || this.chargeIsFailedSecondTime; // eslint-disable-line max-len
    },
    nextPaymentDate() {
      let key = NotificationsKeys.chargeIsFailedFirstTime;
      if (this.chargeIsFailedSecondTime) {
        key = NotificationsKeys.chargeIsFailedSecondTime;
      }
      if (this.chargeIsFailedFirstTime || this.chargeIsFailedSecondTime) {
        const notification = this.userNotifications.find(n => n.notificationKey === key);
        return notification.data.nextPaymentDate;
      }
      return '';
    },
  },
  methods: {
    ...mapActions('userNotifications', [
      'updateUserNotifications',
      'removeUserNotifications',
    ]),
    getUserNotificationByKey(key) {
      return this.userNotifications.find(n => n.notificationKey === key);
    },
    autoUpdateUserNotifications() {
      setTimeout(() => {
        const promises = [];
        if (this.loginInfo) {
          promises.push(this.updateUserNotifications({ dontShowErrors: true }));
        }
        Promise.all(promises).finally(this.autoUpdateUserNotifications);
      }, userNotificationsUpdateMinInterval);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/userNotifications/index.vue